import {
    filters,
    jsonApiFilter,
    jsonApiInclude,
    jsonApiSort,
    preprocessJsonApiQuery,
} from '@dmp/shared/json-api-request';
import { paginationOptionsSchema } from '@dmp/shared/types';
import * as z from 'zod';

export const surveysFilter = filters({
    combined: {
        type: 'combined',
        fields: [
            'qqid',
            'name',
            'createdBy.email',
            'createdBy.firstName',
            'createdBy.lastName',
            'updatedBy.email',
            'updatedBy.firstName',
            'updatedBy.lastName',
        ],
    },
    teamId: { type: 'exact' },
    publicationStatus: { type: 'in' },
    createdById: { type: 'exact' },

    // Date ranges are half-open: `Gte` is inclusive, `Lt` is exclusive. Send ISO datetimes
    // with a zone. To include a date picker's whole end day, send the user's local
    // midnight of the following day as `Lt`.
    createdAtGte: { type: 'gte', field: 'createdAt', format: 'datetime' },
    createdAtLt: { type: 'lt', field: 'createdAt', format: 'datetime' },
    updatedAtGte: { type: 'gte', field: 'updatedAt', format: 'datetime' },
    updatedAtLt: { type: 'lt', field: 'updatedAt', format: 'datetime' },
});

export const surveysQueryValidator = z.preprocess(
    preprocessJsonApiQuery,
    z.object({
        filter: jsonApiFilter(surveysFilter),
        include: jsonApiInclude(['createdBy', 'updatedBy']),
        sort: jsonApiSort([
            'name',
            'createdAt',
            'updatedAt',
            'publicationStatus',
        ]),
        page: paginationOptionsSchema,
    })
);

export type SurveysQuery = z.output<typeof surveysQueryValidator>;
